/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NativeSelect, Switch, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';
import { CircularProgress } from '@material-ui/core';
import * as Yup from 'yup';
import { Body, Cell, Head, Row, Table } from './Table';
import axios from 'axios';
import { BootstrapInput } from './SelectInput';
import { Formik, FieldArray } from 'formik';
import { get, isEqual } from 'lodash';
import { AddButton } from './AddButton';

function ArrayOfMetadata({
  hasPermission,
  buttonRef,
  arrayHelpers,
  intl,
  displayHeader,
  values,
  setFieldValue,
  getFieldProps,
  metadatas,
  setMetadatas,
  type,
  getMetadata,
  options,
  id,
}) {
  useEffect(() => {
    if (buttonRef?.current) {
      buttonRef.current.onclick = () =>
        arrayHelpers.push({ metadataType: 'string' });
    }
  }, [buttonRef]);

  useEffect(() => {
    if (!values.metadatas.length) {
      arrayHelpers.push({ metadataType: 'string' });
    }
  }, [values]);

  async function createMetadata(metadata, index, setField) {
    setField(`metadatas[${index}].submitting`, true);
    delete metadata.hasError;
    if (metadata.metadataType === 'number')
      metadata.value = parseFloat(metadata.value);
    try {
      if (metadata.metadataDefinitionId) {
        await axios.put(`/metadata/${metadata.metadataDefinitionId}`, {
          value: metadata.value,
        });
        setField(`metadatas[${index}].value`, metadata.value);
        const data = [...metadatas];
        data[index] = metadata;
        setMetadatas(data);
      } else {
        const { data } = await axios.post('/metadata', {
          ...metadata,
          ownerType: type,
          ownerId: id,
        });
        metadata.metadataDefinitionId = data.id;
        setMetadatas(val => val.concat(metadata));
      }
    } finally {
      setField(`metadatas[${index}].submitting`, undefined);
    }
  }

  async function deleteMetadata(id, index, remove, setField) {
    setField(`metadatas[${index}].submitting`, true);
    try {
      await axios.delete(`/metadata/${id}`);
      await getMetadata();
    } catch {
      setField(`metadatas[${index}].submitting`, false);
    }
  }

  return (
    <div className="d-flex flex-column h-100 card">
      {displayHeader && (
        <div
          className="card-header d-flex justify-content-between"
          style={{ background: '#002C40', boxShadow: 'none' }}
        >
          <div>
            <div className="d-flex">
              <span className="svg-icon mr-3">
                <SVG
                  cacheRequests
                  uniquifyIDs
                  src={toAbsoluteUrl('/media/svg/senseworks/metadata.svg')}
                />
              </span>
              <h4 className="m-0 title">
                {' '}
                {intl.formatMessage({ id: 'METADATA' })}{' '}
              </h4>
            </div>
            <span className="sub-title">
              {' '}
              {intl.formatMessage({ id: 'METADATA.SUBTITLE' }, { type })}{' '}
            </span>
          </div>
          <div className="d-flex align-items-center">
            {hasPermission('metadata*', 'C') && (
              <AddButton
                onClick={() => arrayHelpers.push({ metadataType: 'string' })}
              />
            )}
          </div>
        </div>
      )}
      <div className="p-0 d-flex flex-column justify-content-between h-100">
        <>
          <div>
            <Table>
              <Head>
                <Cell width={'30%'} className="font-weight-normal">
                  {' '}
                  {intl.formatMessage({ id: 'KEY' })}{' '}
                </Cell>
                <Cell width={'25%'} className="font-weight-normal">
                  {' '}
                  {intl.formatMessage({ id: 'TYPE' })}{' '}
                </Cell>
                <Cell width={'30%'} className="font-weight-normal">
                  {' '}
                  {intl.formatMessage({ id: 'VALUE' })}{' '}
                </Cell>
                <Cell width={'15%'}></Cell>
              </Head>
              <Body>
                {values.metadatas.map((meta, index, arr) => (
                  <Row key={index}>
                    <Cell className="font-weight-normal">
                      {meta.metadataDefinitionId ? (
                        <span> {meta.metadataName} </span>
                      ) : (
                        <>
                          <Autocomplete
                            options={options}
                            getOptionLabel={opt => opt.metadataName || opt}
                            className="form-control form-control-solid py-1 h-auto"
                            onChange={(_, value) => {
                              if (typeof value === 'string') {
                                if (
                                  arr
                                    .filter(x => x.value)
                                    .map(x => x.metadataName)
                                    .includes(value.metadataName)
                                )
                                  setFieldValue(
                                    `metadatas[${index}].hasError`,
                                    true
                                  );
                                else
                                  setFieldValue(
                                    `metadatas[${index}].hasError`,
                                    false
                                  );
                                setFieldValue(
                                  `metadatas[${index}].metadataName`,
                                  value.replace(/:/g, '-')
                                );
                              } else {
                                setFieldValue(
                                  `metadatas[${index}].metadataName`,
                                  value?.metadataName || ''
                                );
                                setFieldValue(
                                  `metadatas[${index}].metadataType`,
                                  ''
                                );
                                setFieldValue(
                                  `metadatas[${index}].metadataType`,
                                  value?.metadataType
                                );
                                if (value?.metadataType === 'boolean')
                                  setFieldValue(
                                    `metadatas[${index}].value`,
                                    true
                                  );
                                else
                                  setFieldValue(
                                    `metadatas[${index}].value`,
                                    ''
                                  );
                              }
                            }}
                            onBlur={e => {
                              e.target.value = e.target.value.replace(
                                /:/g,
                                '-'
                              );
                              if (!meta.metadataName) {
                                const existent = options.find(
                                  x => x.metadataName === e.target.value
                                );
                                setFieldValue(
                                  `metadatas[${index}].metadataType`,
                                  get(existent, 'metadataType', 'string')
                                );
                                if (
                                  existent &&
                                  existent.metadataType === 'boolean'
                                )
                                  setFieldValue(
                                    `metadatas[${index}].value`,
                                    true
                                  );
                              }
                              if (meta.metadataType === 'boolean') {
                                if (
                                  arr.filter(
                                    x => x.metadataName === e.target.value
                                  ).length > 1
                                )
                                  setFieldValue(
                                    `metadatas[${index}].hasError`,
                                    true
                                  );
                              } else {
                                if (
                                  arr
                                    .filter(x => x.value)
                                    .map(x => x.metadataName)
                                    .includes(e.target.value)
                                )
                                  setFieldValue(
                                    `metadatas[${index}].hasError`,
                                    true
                                  );
                                else
                                  setFieldValue(
                                    `metadatas[${index}].hasError`,
                                    false
                                  );
                              }
                              setFieldValue(
                                `metadatas[${index}].metadataName`,
                                e.target.value.replace(/:/g, '-')
                              );
                            }}
                            freeSolo={true}
                            renderInput={params => (
                              <TextField
                                {...params}
                                fullWidth
                                placeholder="Key name"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                }}
                              />
                            )}
                          />
                          {meta.hasError && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {intl.formatMessage({
                                  id: 'ERRORS.EXISTENT_KEY',
                                })}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </Cell>
                    <Cell
                      style={{ verticalAlign: 'top' }}
                      className="font-weight-normal"
                    >
                      <NativeSelect
                        className="form-select"
                        onChange={e => {
                          setFieldValue(
                            `metadatas[${index}].metadataType`,
                            e.target.value
                          );
                          if (e.target.value !== 'boolean')
                            setFieldValue(`metadatas[${index}].value`, '');
                          else setFieldValue(`metadatas[${index}].value`, true);
                        }}
                        input={<BootstrapInput />}
                        disabled={
                          meta.metadataDefinitionId ||
                          options
                            .map(x => x.metadataName)
                            .includes(meta.metadataName)
                            ? true
                            : false
                        }
                      >
                        {opts.map(opt => (
                          <option
                            value={opt.id}
                            selected={meta.metadataType === opt.id}
                            key={opt.id}
                          >
                            {' '}
                            {opt.name}{' '}
                          </option>
                        ))}
                      </NativeSelect>
                    </Cell>
                    <Cell
                      style={{ verticalAlign: 'top' }}
                      className="font-weight-normal text-center"
                    >
                      <>
                        {meta.metadataType === 'number' && (
                          <input
                            autoComplete="on"
                            placeholder="Key value"
                            type="number"
                            defaultValue={meta.value}
                            onChange={e =>
                              setFieldValue(
                                `metadatas[${index}].value`,
                                Number(e.target.value)
                              )
                            }
                            className={`form-control form-control-solid h-auto`}
                          />
                        )}
                        {meta.metadataType === 'boolean' && (
                          <>
                            <Switch
                              {...getFieldProps(`metadatas[${index}].value`)}
                              checked={meta.value}
                            />
                            <span>
                              {' '}
                              {intl.formatMessage({
                                id: values.metadatas[index].value
                                  ? 'YES'
                                  : 'NO',
                              })}{' '}
                            </span>
                          </>
                        )}
                        {meta.metadataType !== 'boolean' &&
                          meta.metadataType !== 'number' && (
                            <input
                              autoComplete="on"
                              placeholder="Key value"
                              onChange={e =>
                                setFieldValue(
                                  `metadatas[${index}].value`,
                                  e.target.value
                                )
                              }
                              type="text"
                              defaultValue={meta.value}
                              className={`form-control form-control-solid h-auto`}
                            />
                          )}
                      </>
                    </Cell>
                    <Cell className="font-weight-normal">
                      {meta.submitting ? (
                        <div className={`d-flex align-items-center`}>
                          <div className="spinner spinner-primary"></div>
                        </div>
                      ) : meta.metadataDefinitionId ? (
                        <div className={`d-flex justify-content-between`}>
                          {!isEqual(meta, metadatas[index]) &&
                            hasPermission('metadata*', 'U') && (
                              <span
                                className="svg svg-icon cursor-pointer"
                                onClick={() =>
                                  createMetadata(meta, index, setFieldValue)
                                }
                              >
                                <SVG
                                  cacheRequests
                                  uniquifyIDs
                                  src={toAbsoluteUrl(
                                    '/media/svg/senseworks/check-filled.svg'
                                  )}
                                />
                              </span>
                            )}
                          {hasPermission('metadata*', 'D') && (
                            <span
                              className="svg svg-icon cursor-pointer"
                              onClick={() =>
                                deleteMetadata(
                                  meta.metadataDefinitionId,
                                  index,
                                  arrayHelpers.remove,
                                  setFieldValue
                                )
                              }
                            >
                              <SVG
                                cacheRequests
                                uniquifyIDs
                                src={toAbsoluteUrl(
                                  '/media/svg/senseworks/delete.svg'
                                )}
                              />
                            </span>
                          )}
                        </div>
                      ) : (!meta.value && meta.metadataType !== 'boolean') ||
                        !meta.metadataName ||
                        meta.hasError ? (
                        <div className={`d-flex justify-content-between`}>
                          <span
                            className="svg svg-icon cursor-pointer"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            <SVG
                              cacheRequests
                              uniquifyIDs
                              src={toAbsoluteUrl(
                                '/media/svg/senseworks/delete.svg'
                              )}
                            />
                          </span>
                        </div>
                      ) : (
                        <div
                          className={`d-flex justify-content-between align-items-center`}
                        >
                          <span
                            className={`svg-icon cursor-pointer`}
                            onClick={() =>
                              createMetadata(meta, index, setFieldValue)
                            }
                          >
                            <SVG
                              cacheRequests
                              uniquifyIDs
                              src={toAbsoluteUrl(
                                '/media/svg/senseworks/check-filled.svg'
                              )}
                            />
                          </span>
                          <span
                            className="svg svg-icon cursor-pointer"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            <SVG
                              cacheRequests
                              uniquifyIDs
                              src={toAbsoluteUrl(
                                '/media/svg/senseworks/delete.svg'
                              )}
                            />
                          </span>
                        </div>
                      )}
                    </Cell>
                  </Row>
                ))}
              </Body>
            </Table>
          </div>
        </>
      </div>
    </div>
  );
}

function getSchema(intl) {
  return Yup.array().of(
    Yup.object().shape({
      metadataName: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
      metadataType: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
      value: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
    })
  );
}

const opts = [
  { id: 'string', name: 'String' },
  { id: 'number', name: 'Number' },
  { id: 'boolean', name: 'Boolean' },
];

function MetadataMenu({
  intl,
  type,
  id,
  hasPermission,
  buttonRef,
  displayHeader = true,
}) {
  const [options, setOptions] = useState([]);
  const [metadatas, setMetadatas] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getMetadata();
  }, [type, id]);

  async function getMetadata() {
    if (id && id !== 'new') {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `/metadata?ownerType=${type}&ownerId=${id}`
        );
        if (data) {
          setOptions(data.options);
          setMetadatas(data.values);
        }
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <Formik
      initialValues={{ metadatas }}
      enableReinitialize
      validationSchema={getSchema(intl)}
    >
      {isLoading ? (
        <div className="d-flex flex-center h-100">
          <CircularProgress color="secondary"></CircularProgress>
        </div>
      ) : (
        ({ values, setFieldValue, getFieldProps }) => (
          <FieldArray
            name="metadatas"
            render={arrayHelpers => (
              <ArrayOfMetadata
                hasPermission={hasPermission}
                buttonRef={buttonRef}
                arrayHelpers={arrayHelpers}
                intl={intl}
                values={values}
                setFieldValue={setFieldValue}
                getFieldProps={getFieldProps}
                options={options}
                setLoading={setLoading}
                getMetadata={getMetadata}
                setMetadatas={setMetadatas}
                metadatas={metadatas}
                type={type}
                displayHeader={displayHeader}
                id={id}
              />
            )}
          />
        )
      )}
    </Formik>
  );
}

export default MetadataMenu;
